import { css } from 'styled-components';
import { colors } from '../../atoms/colors/colors';
import { spacing } from '../../atoms/spacing/spacing';
export const cardLightTheme = {
    base: css `
    background-color: ${colors.white};
    border-radius: 6px;
    padding: ${spacing.spacing32};
    box-shadow: 0 0 16px -6px ${colors.coolgrey400};
  `,
};
//# sourceMappingURL=light-theme.js.map